import { type ExamCenterCourse } from '../../types';

export function mapExamCenterCourseData(examCenterCourse: ExamCenterCourse) {
  const { id, createdAt, examCourse } = examCenterCourse;

  if (!examCourse) {
    throw new Error('Exam course is required');
  }

  if (!examCourse.examId) {
    throw new Error('Exam course exam ID is required');
  }

  if (!examCourse.code) {
    throw new Error('Exam course code is required');
  }

  if (!examCourse.name) {
    throw new Error('Exam course name is required');
  }

  if (!examCourse.type) {
    throw new Error('Exam course type is required');
  }

  if (!examCourse.language) {
    throw new Error('Exam course language is required');
  }

  return {
    id,
    examId: examCourse.examId,
    code: examCourse.code,
    name: examCourse.name,
    type: examCourse.type,
    language: examCourse.language,
    createdAt,
  };
}
